/* Pop-up de newsletter: amplía el pop-in del tema con apertura automática (espera en escritorio, desplazamiento en mobile), frecuencia, modo modal solo en mobile y pestaña lateral para volver a abrirlo */
(() => {
  const SEEN_KEY = "wim-nlp:seen";
  const FILLED_KEY = "theme:popup-filled";
  const desktop = window.matchMedia("(min-width: 768px)");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  const read = (storage, key) => {
    try {
      return window[storage].getItem(key);
    } catch (error) {
      return null;
    }
  };

  const write = (storage, key, value) => {
    try {
      window[storage].setItem(key, value);
    } catch (error) {}
  };

  customElements.whenDefined("pop-in").then(() => {
    if (customElements.get("wim-newsletter-popup")) return;

    const PopIn = customElements.get("pop-in");

    class WimNewsletterPopup extends PopIn {
      connectedCallback() {
        super.connectedCallback();

        const signal = this.abortController.signal;
        this.tab = this.hasAttribute("tab") ? document.getElementById(this.getAttribute("tab")) : null;

        if (this.hasAttribute("subscribed")) write("localStorage", FILLED_KEY, "true");

        this.addEventListener("toggle", () => this.#onToggle(), { signal });
        this.addEventListener("click", (event) => {
          if (event.target === this || event.target.classList.contains("wim-nlp__wrap")) this.hide();
        }, { signal });
        document.addEventListener("keydown", (event) => {
          if (event.key === "Escape" && this.open && !this.shouldTrapFocus) this.hide();
        }, { signal });
        this.tab?.addEventListener("click", () => { this.openedFromTab = true; }, { signal });

        this.#syncTab();

        if (this.open || Shopify.designMode || this.isSubscribed || !this.hasAttribute("auto-open") || !this.isDue) return;

        setTimeout(() => { if (desktop.matches) this.#autoShow(); }, parseInt(this.getAttribute("delay") || 0) * 1000);

        const scrollRatio = parseInt(this.getAttribute("scroll") || 0) / 100;
        const onScroll = () => {
          if (desktop.matches || window.scrollY < window.innerHeight * scrollRatio) return;
          window.removeEventListener("scroll", onScroll);
          this.#autoShow();
        };
        window.addEventListener("scroll", onScroll, { passive: true, signal });
        onScroll();
      }

      get shouldTrapFocus() {
        return !desktop.matches;
      }

      get shouldLock() {
        return !desktop.matches;
      }

      get isSubscribed() {
        return read("localStorage", FILLED_KEY) === "true";
      }

      get hasBeenSeen() {
        return read("sessionStorage", SEEN_KEY) !== null || read("localStorage", SEEN_KEY) !== null;
      }

      get isDue() {
        if (this.getAttribute("frequency") === "days") {
          const last = parseInt(read("localStorage", SEEN_KEY) || 0);
          return Date.now() - last > parseInt(this.getAttribute("frequency-days") || 1) * 86400000;
        }

        return read("sessionStorage", SEEN_KEY) === null;
      }

      createEnterAnimationControls() {
        const duration = reducedMotion.matches ? 0 : 400;
        this.animate({ opacity: [0, 1] }, { duration: duration * .75, fill: "forwards" });

        return this.querySelector(".wim-nlp__box").animate(
          { transform: ["translateY(12px)", "translateY(0)"] },
          { duration, easing: "cubic-bezier(.2, .7, .2, 1)", fill: "forwards" }
        );
      }

      createLeaveAnimationControls() {
        return this.animate({ opacity: [1, 0] }, { duration: reducedMotion.matches ? 0 : 250, fill: "forwards" });
      }

      /* Abre solo si no hay otro panel del tema abierto; si lo hay, lo intenta más tarde */
      #autoShow() {
        if (this.open) return;
        if (document.documentElement.classList.contains("lock")) {
          setTimeout(() => this.#autoShow(), 3000);
          return;
        }
        this.show();
      }

      #onToggle() {
        this.setAttribute("aria-modal", this.shouldTrapFocus ? "true" : "false");

        if (this.open) {
          if (!Shopify.designMode) {
            write("sessionStorage", SEEN_KEY, String(Date.now()));
            write("localStorage", SEEN_KEY, String(Date.now()));
          }

          if (this.openedFromTab && !this.shouldTrapFocus) {
            requestAnimationFrame(() => this.querySelector('input:not([type="hidden"]), button')?.focus({ preventScroll: true }));
          }
        } else {
          const focusWasInside = this.contains(document.activeElement) || this.openedFromTab;
          this.openedFromTab = false;
          this.#syncTab();
          if (focusWasInside && !this.shouldTrapFocus && this.tab && !this.tab.hidden) this.tab.focus({ preventScroll: true });
        }

        if (this.open) this.#syncTab();
      }

      #syncTab() {
        if (!this.tab) return;
        this.tab.hidden = this.open || (!Shopify.designMode && (this.isSubscribed || !this.hasBeenSeen));
      }
    }

    customElements.define("wim-newsletter-popup", WimNewsletterPopup);
  });
})();
